import { render, staticRenderFns } from "./VideoSlider.vue?vue&type=template&id=a7d843d8"
import script from "./VideoSlider.vue?vue&type=script&lang=js"
export * from "./VideoSlider.vue?vue&type=script&lang=js"
import style0 from "./VideoSlider.vue?vue&type=style&index=0&id=a7d843d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports